import { coreInitiativesCommentsByIdDeleteAsyncSlice } from './delete';
import { coreInitiativesCommentsByIdPatchAsyncSlice } from './patch';

export const { requestDeleteCoreInitiativesCommentsById, resetDeleteCoreInitiativesCommentsById } =
	coreInitiativesCommentsByIdDeleteAsyncSlice.asyncActionCreators;

export const { requestPatchCoreInitiativesCommentsById, resetPatchCoreInitiativesCommentsById } =
	coreInitiativesCommentsByIdPatchAsyncSlice.asyncActionCreators;
